export const methodIcons = {
    'Auth0': '/static/images/auth0.svg',
    'FirebaseAuth': '/static/images/firebase.svg',
    'JWT': '/static/images/jwt.svg',
    'LOGO': '/static/images/main-logo.png'
};